import type { SVGProps } from "react";
const SenecPictogramList = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M9 5C9 3.34315 10.3431 2 12 2H16C16.5523 2 17 2.44772 17 3C17 3.55228 16.5523 4 16 4H12C11.4477 4 11 4.44772 11 5V11C11 11.5523 11.4477 12 12 12H18C18.5523 12 19 11.5523 19 11V9C19 8.44772 19.4477 8 20 8C20.5523 8 21 8.44772 21 9V11C21 12.6569 19.6569 14 18 14H12C10.3431 14 9 12.6569 9 11V5Z"
            fill="currentColor"
        />
        <path
            d="M20.7071 4.70711L15 10.4142L12.2929 7.70711L13.7071 6.29289L15 7.58579L19.2929 3.29289L20.7071 4.70711Z"
            fill="currentColor"
        />
        <path d="M24 7H39V5H24V7Z" fill="currentColor" />
        <path d="M24 11H35V9H24V11Z" fill="currentColor" />
        <path d="M39 23H24V21H39V23Z" fill="currentColor" />
        <path d="M35 27H24V25H35V27Z" fill="currentColor" />
        <path d="M24 39H39V37H24V39Z" fill="currentColor" />
        <path d="M24 43H35V41H24V43Z" fill="currentColor" />
        <path
            d="M12 18C10.3431 18 9 19.3431 9 21V27C9 28.6569 10.3431 30 12 30H18C19.6569 30 21 28.6569 21 27V25C21 24.4477 20.5523 24 20 24C19.4477 24 19 24.4477 19 25V27C19 27.5523 18.5523 28 18 28H12C11.4477 28 11 27.5523 11 27V21C11 20.4477 11.4477 20 12 20H16C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18H12Z"
            fill="currentColor"
        />
        <path
            d="M20.7071 20.7071L19.2929 19.2929L15 23.5858L13.7071 22.2929L12.2929 23.7071L15 26.4142L20.7071 20.7071Z"
            fill="currentColor"
        />
        <path
            d="M9 37C9 35.3431 10.3431 34 12 34H16C16.5523 34 17 34.4477 17 35C17 35.5523 16.5523 36 16 36H12C11.4477 36 11 36.4477 11 37V43C11 43.5523 11.4477 44 12 44H18C18.5523 44 19 43.5523 19 43V41C19 40.4477 19.4477 40 20 40C20.5523 40 21 40.4477 21 41V43C21 44.6569 19.6569 46 18 46H12C10.3431 46 9 44.6569 9 43V37Z"
            fill="currentColor"
        />
        <path
            d="M20.7071 36.7071L15 42.4142L12.2929 39.7071L13.7071 38.2929L15 39.5858L19.2929 35.2929L20.7071 36.7071Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramList;
